/** 简体中文服务条款（正文请在本地文件补充） */
export const termsTitle = 'BILION PASS 服务条款';

export const termsBody = `
本使用条款（以下简称 “本条款”）
本条款旨在规定由 Japan DX 株式会社（以下简称 “本公司”）运营的 BILION PASS 网站（以下简称 “本网站”）上所提供的各项服务（以下简称 “本服务”）的使用条件。本网站用户（以下简称 “用户”）在使用本服务时，须遵守本条款之约定。
第一条（本条款的适用范围）
本条款适用于所有使用本服务的用户。
除本条款外，本公司就本服务另行制定的各项规则，均构成本条款的组成部分。
若本条款规定与前款所述本公司另行制定的各项规则内容不一致，以该等另行制定的规则内容为准优先适用。
第二条（条款的变更）
本公司可在无需征得用户同意的前提下，对本条款进行条款的新增、修改、删除等调整。届时，本服务的使用条件以变更后的本条款为准。
除本公司另行规定外，变更后的条款自在本网站公示之日起生效；用户在条款变更后继续使用本服务的，视为同意变更后的本条款。
第三条（使用环境）
使用本网站须接入互联网（网页端）。用户需自行承担责任与费用，准备所需设备、软件、通信工具等，并对其进行妥善安装与操作。
本公司不参与用户上述准备工作及操作方式，亦不承担任何相关责任。
第四条（知识产权）
本网站及本网站刊载的作品等（包括但不限于文字、照片、地图、绘画、设计图、图表、影像、音乐、程序、数据库等作品，以及二次创作作品、编辑作品）的著作权归本公司及其他相关权利人所有。
未经本公司及其他权利人许可，严禁对上述作品等进行复制、上演、演奏、放映、公众传播（含可传送化）、口述、展示、发行、转让、出租、翻译、改编、改动等一切行为。
本网站及本服务中使用的商号、商品名称、服务名称、标识等，为本公司及其他相关权利人的注册商标或商标。未经本公司及其他权利人许可，不得擅自使用该等商标。
第五条（本网站的链接）
用户禁止以符合以下任一情形，或存在该等风险的方式设置指向本网站的链接：
① 以营利为目的；
② 对图片进行直接链接（图片显示相关）；
③ 可能给本公司造成社会或经济损失；
④ 将本网站嵌入独立框架进行链接；
⑤ 链接至第三方享有著作权且禁止链接的文章；
⑥ 其他本公司判断可能妨碍本服务正常运营的情形。
第六条（会员注册）
本网站可无需注册为会员（指完成会员注册手续并使用本服务的用户，下同）直接使用，但使用本服务中部分功能时，须完成会员注册。
进行会员注册时，须遵守以下条件。若违反下述规定，或本公司判断用户未提供真实、准确信息，本公司可删除该会员的注册信息，并拒绝其今后使用本服务。
① 会员注册表单须由申请人本人填写自身真实、准确的信息，并通过本网站提交至本公司。
② 为确保注册信息始终真实、准确，信息发生变更时，用户应及时予以修改。同时，会员须妥善保管自身账号密码。
会员注册时提交的注册信息，以及使用本服务过程中提供的信息，所有权归本公司所有。
本公司除可按本条款约定使用外，还可依据本公司制定的隐私政策，在与本服务相关范围内，或出于本服务使用以外的目的使用该等信息。
本公司向第三方披露该等信息时，应事先取得相关会员的同意。
本公司可基于用户提供的个人信息，通过本服务以电子邮件、网站公告等形式，向会员推送个性化信息，以及本公司及业务合作方的商品、服务介绍等内容。
本公司可向会员征求问卷、访谈等合作，以供本公司或业务合作方经营参考。
会员出现以下任一情形的，丧失会员资格，视为自动退会：
① 本公司撤销对该会员的入会批准；
② 该会员违反本条款任一条款，本公司决定将其除名；
③ 该会员按规定流程向本公司申请退会。
本公司判断有必要与会员联络或通知时，原则上通过注册邮箱发送邮件进行。
第七条（会员信息的处理方式）
会员注册信息及本公司通过其他途径获取的会员相关信息，将依照本公司制定的隐私政策进行处理。
第八条（禁止行为）
用户在使用本网站时，禁止实施以下行为：
① 篡改、删除通过本网站可使用的信息；
② 尝试非法接入与本网站相连的其他计算机系统或网络；
③ 侵害或可能侵害其他用户、第三方或本公司的著作权、商标权等知识产权的行为；
④ 损害或可能损害其他用户、第三方或本公司名誉或信用的行为；
⑤ 侵害或可能侵害其他用户、第三方或本公司的财产、隐私、肖像权、商品化权等权利的行为；
⑥ 擅自使用、转让、贩卖其他用户邮箱地址等信息的行为；
⑦ 未经本公司许可，将 AI 生成内容用于商业目的转载、销售的行为；
⑧ 非法复制、篡改优惠券或将优惠券转售给第三方的行为；
⑨ 破坏、干扰服务器或网络功能的行为；
⑩ 以经营活动、营利为目的的行为及相关准备行为；
⑪ 使用或提供计算机病毒等有害程序，或存在该等风险的行为；
⑫ 冒充其他用户、第三方或本公司使用本服务的行为；
⑬ 给其他用户、第三方或本公司造成不利或损害，或存在该等风险的行为；
⑭ 违反公序良俗，或存在该等风险的行为；
⑮ 实施犯罪行为或与犯罪相关行为，或存在该等风险的行为；
⑯ 其他违反法律法规、条例，或存在该等风险的行为；
⑰ 民族、种族歧视行为；
⑱ 妨碍本网站运营的行为；
⑲ 助长上述各款所列行为的行为；
⑳ 其他本公司认定为不当的行为。
第九条（损害赔偿责任）
用户因违反本条款约定，给其他用户及本公司造成损害的，应赔偿相应损失（含律师费）。
若因违反本条款引发与第三方的纠纷，用户应自行承担责任与费用予以解决，不得给本公司造成损害或困扰。
第十条（免责事项）
本公司在提供本服务时，对以下事项不作任何保证：
① 完全满足用户的需求；
② 刊载信息具备时效性、准确性、合法性、实用性、完整性；
③ 不发生服务中断、系统故障、漏洞、缺陷等问题；
④ 对缺陷进行修复；
⑤ 不存在计算机病毒及其他有害程序；
⑥ 用户不会因使用或无法使用本服务遭受损失。
本服务当前提供旅游相关信息与功能，为提升服务品质，本公司可在不事先通知的前提下，对该等内容进行新增、修改、暂停、删除等调整。
本公司在以下情形下，可不经事先通知暂停或终止本网站运营：
① 需定期或紧急对信息、功能或系统进行变更；
② 需定期或紧急对系统或设备进行检修；
③ 因自然灾害、地震、停电等原因无法继续提供本服务；
④ 其他因突发情况需暂停、终止服务的情形。
无论何种原因，本公司对用户因使用本服务所产生的任何损失，以及因本服务信息、功能变更或运营暂停、终止所产生的任何损失，均不承担责任。
由本网站链出或链入本网站的非本公司运营的第三方网站（以下简称 “外链网站”）内容，由各外链网站运营方自行负责管理。
用户使用外链网站时，应遵守各网站的使用条款及著作权相关规定。
本公司对外链网站内容，以及用户因使用外链网站所产生的任何损失，均不承担责任。
因自然灾害等不可抗力、经营上的合理事由或经营战略判断，本公司可终止本服务的全部或部分内容。
第十一条（禁止转让）
用户不得将接受本服务的权利向第三方转让、买卖、变更名义、设定质押或用于其他担保等。会员注册具有人身专属性。
第十二条（咨询方式）
有关本服务的咨询，须通过本公司指定方式进行。
关于用户的意见、咨询等
未经本公司事先书面同意，用户禁止对本公司针对其意见、咨询所作出的邮件等回复进行复制、公众传播、转发、转载或向第三方披露。
第十三条（准据法・裁判管辖）
本条款的解释以日本法律为准据法。
因本服务产生纠纷的，以本公司总公司所在地管辖法院为专属合意管辖法院。
以上
本公司就本服务制定的各项规则
AI 旅行方案生成服务
本服务利用人工智能（AI），根据用户需求生成旅行方案。
AI 生成的方案（路线、所需时间、设施信息等），不保证绝对准确、最新或完整。用户实际出行时，须自行事先确认公共交通运行状况及设施营业时间。
其他服务
有关适用于本服务的相关条件，请查阅从本网站跳转至对应页面所刊载的条款。
以上
`;
